import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonCol, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonLabel, IonDatetime, IonFooter } from '@ionic/react';

import { TakePhoto, photos } from './TakePhoto';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';

export function CreateEmployeeModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [selectedFile, setSelectedFile] = useState(null);
    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [attachement, setAttachement] = useState(null);

    let employeeCompanyRoleRef = useRef('individual_contributor');
    let employeeFirstNameRef = useRef();
    let employeeLastNameRef = useRef();
    let initialEmployeePasswordRef = useRef();
    let employeeHireDateRef = useRef();
    let employeeHourlyPayRef = useRef();
    let employeeJobFunctionRef = useRef();
    let employeePhoneNumberRef = useRef();
    let employeeEmailAddressRef = useRef();
    let employeeAddressNumberRef = useRef();
    let employeeStreetNameRef = useRef();
    let employeeCityRef = useRef();
    let employeeCityDistrictRef = useRef();
    //let employeeNearestLandmarkRef = useRef();
    let employeeCountryRegionRef = useRef();
    let employeeCountryRef = useRef();
    let employeeDigitalAddressIDRef = useRef();

    let selectedFileRef = useRef();

    function createEmployee(e)
    {

        e.preventDefault();

        /*
        let formData = new FormData();
        formData.append('Tracker', 74500);
        formData.append('user', acctID);
        formData.append('xEmployeeCompanyRole', employeeCompanyRoleRef.current.value);
        formData.append('xEmployeeFirstName', employeeFirstNameRef.current.value);
        formData.append('xEmployeeLastName', employeeLastNameRef.current.value);
        formData.append('xInitialEmployeePassword', initialEmployeePasswordRef.current.value);
        formData.append('xEmployeeHireDate', employeeHireDateRef.current.value);
        formData.append('xEmployeeHourlyPay', employeeHourlyPayRef.current.value);
        formData.append('xEmployeeJobFunction', employeeJobFunctionRef.current.value);
        formData.append('xEmployeePhoneNumber', employeePhoneNumberRef.current.value);
        formData.append('xEmployeeEmailAddress', employeeEmailAddressRef.current.value);

        //formData.append('xEmployeeHomeAddress', employeeHomeAddressRef.current.value);
        formData.append('xEmployeeAddressNumber', employeeAddressNumberRef.current.value);
        formData.append('xEmployeeStreetName', employeeStreetNameRef.current.value);
        formData.append('xEmployeeCity', employeeCityRef.current.value);
        formData.append('xEmployeeCityDistrict', employeeCityDistrictRef.current.value);
        //formData.append('xEmployeeNearestLandmark', employeeNearestLandmarkRef.current.value);
        formData.append('xEmployeeCountryRegion', employeeCountryRegionRef.current.value);
        formData.append('xEmployeeCountry', employeeCountryRef.current.value);
        formData.append('xEmployeeDigitalAddressID', employeeDigitalAddressIDRef.current.value)

        formData.append('xSupportingDocumentation', selectedFileRef.current.value);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74500_retail',
                user: acctID,
                xEmployeeCompanyRole: employeeCompanyRoleRef.current.value,
                xEmployeeFirstName: employeeFirstNameRef.current.value,
                xEmployeeLastName: employeeLastNameRef.current.value,
                xInitialEmployeePassword: initialEmployeePasswordRef.current.value,
                xEmployeeHireDate: employeeHireDateRef.current.value,
                xEmployeeHourlyPay: employeeHourlyPayRef.current.value,
                xEmployeeJobFunction: employeeJobFunctionRef.current.value,
                xEmployeePhoneNumber: employeePhoneNumberRef.current.value,
                xEmployeeEmailAddress: employeeEmailAddressRef.current.value,
                //xEmployeeHomeAddress:  employeeHomeAddressRef.current.value,
                xEmployeeAddressNumber: employeeAddressNumberRef.current.value,
                xEmployeeStreetName: employeeStreetNameRef.current.value,
                xEmployeeCity: employeeCityRef.current.value,
                xEmployeeCityDistrict: employeeCityDistrictRef.current.value,
                //xEmployeeNearestLandmark: employeeNearestLandmarkRef.current.value,
                xEmployeeCountryRegion: employeeCountryRegionRef.current.value,
                xEmployeeCountry: employeeCountryRef.current.value,
                xEmployeeDigitalAddressID: employeeDigitalAddressIDRef.current.value,
                xSupportingDocumentation: attachement,
                //xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            selectedFileRef.current.value = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            //setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            selectedFileRef.current.value = event.target.files[0];
            //setSelectedFile(event.target.files[0]);
        }


    }

    function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        //setProductImageNumber("1");
        setAttachement(event);
        setTakePhotoStatus1(false);
    }

    function handleFileChange(event) {

        if(event[0] = "1")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
           // setProductImageNumber(event[1].target.dataset.id);
           setAttachement(file);
        }
    }
    /*handleCreateEmployeeCompanyRole(e) 
    {   
        e.persist(); 
        employeeCompanyRoleRef.current.value = e.target.value;

    }*/

    // function onSubmitPasswordHandler(enteredPassword)
    // {
    //     //setEnteredPassword(event);
    //     createEmployee(enteredPassword);
    // }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <form onSubmit={createEmployee}>
        <IonHeader style={{color: "black"}}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonText>CREATE EMPLOYEE</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
        <IonContent className='grid_content_details'>
        <IonGrid>
            <IonRow>
                <IonCol>
                    <IonLabel for="employeeRole">Company Role </IonLabel>
                    {/*<select name="employeeRole" id='employeeRole' ref={(e) => handleCreateEmployeeCompanyRole(e) }>*/}
                    <select name="employeeRole" id='employeeRole' ref={employeeCompanyRoleRef }>
                        <option value='individual_contributor'>Individual Contributor</option>
                        <option value='front_desk'>Front Desk</option>
                        <option value='cleaning_service'>Cleaning Services</option>
                        <option value='manager'>Manager</option>
                    </select>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>First Name: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter First Name' ref={ employeeFirstNameRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Last Name: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Last Name' ref={ employeeLastNameRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel> Create Password: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter employee initial Login Password' ref={ initialEmployeePasswordRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Hire Date </IonLabel>

                    {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder='Select Hire Date' ref={employeeHireDateRef}>  </IonDatetime> }         {/*text={startDateRange.toLocaleString('en-us', {month: 'long', day: '2-digit'}) +', '+startDateRange.getFullYear()} */}
                    {authenticatedMerchent_context.device == 'desktop' &&  <IonInput className='professional-input' type='date' placeholder='Select Hire Date' ref={employeeHireDateRef}> </IonInput>  }

                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Monthly Pay </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={ employeeHourlyPayRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Job Function </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeJobFunctionRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel> Momo Number: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeePhoneNumberRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Email Address: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeEmailAddressRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Home Address Number: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeAddressNumberRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Street Name: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeStreetNameRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>City: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeCityRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>City District: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeCityDistrictRef }></IonInput>
                </IonCol>
                {/*<IonCol>
                    <IonLabel>Nearest Landmark: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={employeeNearestLandmarkRef }></IonInput>
                </IonCol>*/}
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Country: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={ employeeCountryRef }></IonInput>
                </IonCol>
                <IonCol>
                    <IonLabel>Country Region: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Item Description' ref={ employeeCountryRegionRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel>Digital Address ID: </IonLabel>
                    <IonInput className='professional-input' placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonLabel>Attachement </IonLabel>
                <IonCol> 
                    <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                    {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                </IonCol>
                <IonCol>
                    <input
                        type="file"
                        accept="image/jpeg"
                        data-id='1'
                        onChange={(e) => handleFileChange(["1", e])}
                        required
                    />
                </IonCol>
            </IonRow>
        </IonGrid>
        </IonContent>
        <IonFooter className='appFooter'>
            <IonGrid>
                    <IonRow>
                        <IonCol size="6">
                           {authenticatedMerchent_context.initialSetup?.details?.step_3 == false ||
                            (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '6' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                           ? <IonButton type='submit' className='flash-tutorial'> Confirm </IonButton>
                            : <IonButton type='submit'> Confirm </IonButton>}
                        </IonCol>
                        <IonCol size="6">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </form>
        </IonModal>) : null}
    </React.Fragment>
    )
}